<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>店铺设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <el-form
        :model="shopForm"
        :rules="rules"
        ref="shopForm"
        label-width="98px"
        class="shopsetting-form"
        width="328px"
        :hide-required-asterisk="true"
      >
        <el-form-item label="店铺logo" prop="shopLogo">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'shopLogo');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'shopLogo');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="shopLogo"
              :on-exceed="limitTip"
              :limit="1"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(1, 'shopLogo')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item label="店铺二维码" v-show="isOwn && shop.edcShopType != 5">
          <el-link
            v-if="!shopForm.isVerified"
            @click="linkTo('/setting/certification')"
            type="primary"
            >去认证</el-link
          >
          <div v-else class="qrcode-img" id="qrcode">
            <qrcode
              :value="shopForm.edcShopQRcode"
              :options="{ size: 90 }"
              class="scan-code-img"
            ></qrcode>
            <img class="bg" src="@/assets/img/setting/shopping-code.jpg" />
            <!-- <img class="logo" :src="shopForm.shopLogo" /> -->
            <div class="name onetxt">{{ shopForm.shopName }}</div>
            <div class="phone">店铺联系方式：{{ shopForm.shopTel }}</div>
            <div class="addresss">店铺地址：{{ shopForm.shopAddress }}</div>
            <div class="info">由网付旗下码点餐提供技术支持</div>
          </div>
          <el-link
            v-if="shopForm.isVerified"
            :underline="false"
            type="primary"
            @click="downQrcode"
            >下载</el-link
          >
        </el-form-item>
        <el-form-item label="店铺名称" prop="shopName">
          <el-input v-model="shopForm.shopName" placeholder="请填写店铺名称"></el-input>
        </el-form-item>
        <el-form-item label="店铺公告" prop="shopNotice">
          <el-input
            type="textarea"
            placeholder="请填写店铺公告"
            v-model="shopForm.shopNotice"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="shopTel">
          <el-input v-model="shopForm.shopTel" placeholder="请填写联系电话"></el-input>
        </el-form-item>
        <el-form-item label="营业时间" prop="businessHours" v-if="shop.edcShopType != 5">
          <el-time-select
            v-model="shopForm.startTime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '24:00',
            }"
            placeholder="请选择开始时间"
          ></el-time-select>
          <el-time-select
            v-model="shopForm.endTime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '24:00',
            }"
            placeholder="请选择结束时间"
          ></el-time-select>
          <span class="tips">不在营业时间内，将无法接单，即使店铺状态为正常运营</span>
        </el-form-item>
        <!-- <el-form-item label="门店所在地" prop="cityName">
          <el-cascader
            v-model="shopForm.cityName"
            @change="cityNameCascaderHandler"
            :options="cityOptions"
            :props="{ expandTrigger: 'click', value: 'label' }"
            placeholder="请选择门店所在地"
          ></el-cascader>
        </el-form-item> -->
        <el-form-item label="详细地址" prop="shopAddress">
          <el-input v-model="shopForm.shopAddress" placeholder="请填写店铺地址">
            <!-- <template slot="append">
              <el-button @click="showDialogMap">去定位</el-button>
            </template> -->
          </el-input>
        </el-form-item>
        <el-form-item label="经纬度:" prop="center">
          <el-input
            v-model="mapCenterInputText"
            placeholder="请填写经纬度"
            @blur="mapCenterInputTextBlur(shopForm)"
          >
            <template slot="append">
              <el-button type="primary" @click="showDialogMap()">去获取</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="开启功能" prop="edcfuncTags" v-if="shop.edcShopType != 5">
          <div class="func-container">
            <span class="status" :class="shopForm.takeoutStatus ? 'open' : 'close'"
              >外卖({{ shopForm.takeoutStatus ? "已开启" : "已关闭" }})</span
            >
            <el-switch
              class="float-right"
              v-model="shopForm.takeoutStatus"
              active-color="#67c23a"
              inactive-color="#f57878"
            ></el-switch>
          </div>
          <div class="func-container">
            <span class="status" :class="shopForm.tangStatus ? 'open' : 'close'"
              >堂食({{ shopForm.tangStatus ? "已开启" : "已关闭" }})</span
            >
            <el-switch
              class="float-right"
              v-model="shopForm.tangStatus"
              active-color="#67c23a"
              inactive-color="#f57878"
            ></el-switch>
          </div>
        </el-form-item>
        <el-form-item
          label="店铺类型"
          prop="shopCategoryIdTags"
          v-if="shop.edcShopType != 5"
        >
          <el-cascader
            :props="{
              checkStrictly: true,
            }"
            :options="shopCategoryIdTagsOptions"
            v-model="shopForm.shopCategoryIdTags"
            clearable
            placeholder="请选择店铺类型"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="需填写人数（堂食）" prop="needChoosePeopleNum">
          <el-radio-group v-model="shopForm.needChoosePeopleNum">
            <el-radio :label="1">需要</el-radio>
            <el-radio :label="0">不需要</el-radio>
          </el-radio-group>
          <span class="tips">
            <i class="el-icon-warning-outline"></i
            >用户填写人数，商家便可为客户准备碗筷数量等
          </span>
        </el-form-item>
        <el-form-item label="支付方式" prop="payMethod" v-if="shop.edcShopType != 5">
          <el-radio-group v-model="shopForm.payMethod">
            <el-radio :label="1">在线</el-radio>
            <el-radio :label="0">前台支付</el-radio>
          </el-radio-group>
          <span class="tips">
            在线支付需要店铺认证通过
            <el-link
              v-if="!shopForm.isVerified"
              @click="linkTo('/setting/certification')"
              type="primary"
              >去认证</el-link
            >
          </span>
        </el-form-item>
        <el-form-item
          label="自动清桌"
          prop="isAutoClearTable"
          v-if="shop.edcShopType != 5"
        >
          <el-radio-group v-model="shopForm.isAutoClearTable">
            <el-radio :label="0">手动</el-radio>
            <el-radio :label="1">自动</el-radio>
          </el-radio-group>
          <span class="tips">
            <i class="el-icon-warning-outline"></i
            >开启自动接单，当客户买完单，桌位状态自动改变为闲置。
          </span>
        </el-form-item>
        <el-form-item
          label="取餐码"
          prop="isAutoOrderNumber"
          v-if="shop.edcShopType != 5"
        >
          <el-radio-group v-model="shopForm.isAutoOrderNumber">
            <el-radio :label="1">默认自动</el-radio>
            <el-radio :label="0">手动输入</el-radio>
          </el-radio-group>
          <span class="tips">
            <i class="el-icon-warning-outline"></i
            >用户在线下单时会打印出一张取餐码，“默认”是系统按序打印，“手动输入”则是商家可自定义手动编写取餐码
          </span>
        </el-form-item>
        <el-form-item label="就餐支付方式" prop="mealMethod" v-if="shop.edcShopType != 5">
          <el-radio-group v-model="shopForm.mealMethod">
            <el-radio :label="1">先就餐后付款</el-radio>
            <el-radio :label="2">先付款后就餐</el-radio>
          </el-radio-group>
          <span class="tips">
            <i class="el-icon-warning-outline"></i>支持扫码点餐和桌位点餐
          </span>
        </el-form-item>
        <el-form-item label="门脸照片" prop="shopFaceImage">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'shopFaceImage');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'shopFaceImage');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="shopFaceImage"
              :on-exceed="limitTip"
              :limit="1"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(1, 'shopFaceImage')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="店铺实景 (可多图)" prop="shopImages">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'shopImages');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'shopImages');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="shopImages"
              :before-remove="beforeRemove"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(999, 'shopImages')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="店铺头部 （背景图）" prop="bannerImage">
          <div>
            <span class="tips">（图片建议像素：702x234）</span>
            <el-upload
              :disabled="uploadDisabled"
              class="banner-image"
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'bannerImage');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'bannerImage');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="bannerImage"
              :on-exceed="limitTip"
              :limit="1"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(1, 'bannerImage')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="店铺形象图 （背景）" prop="indexBackgroundImage">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'indexBackgroundImage');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'indexBackgroundImage');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="indexBackgroundImage"
              :on-exceed="limitTip"
              :limit="1"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(1, 'indexBackgroundImage')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="轮播图" prop="bannerImages" v-if="shop.edcShopType != 5">
          <div>
            <span class="tips">（根据选择的模板说明提示，上传相应的尺寸）</span>
            <el-upload
              :disabled="uploadDisabled"
              class="banner-image"
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'bannerImages');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'bannerImages');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="bannerImages"
              :on-exceed="limitTip"
              :limit="5"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(5, 'bannerImages')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <div class="inline-title">主体认证</div>
        <el-form-item label="店铺认证">
          <el-link
            :type="shopForm.isVerified ? 'success' : 'danger'"
            class="verified-status"
            disabled
            >{{ shopForm.isVerified ? "已认证" : "未认证" }}</el-link
          >
          <el-button
            v-if="!shopForm.isVerified"
            type="primary"
            size="small"
            @click="linkTo('/setting/certification')"
            >去认证</el-button
          >
        </el-form-item>
        <el-form-item label="开票认证">
          <!-- <el-link :type="shopForm.nuonuoAccessToken ? 'success':'danger'" class="verified-status" disabled>{{shopForm.nuonuoAccessToken ? "已认证":"未认证"}}</el-link> -->
          <!-- <el-input
            class="taxnum-input"
            size="small"
            placeholder="请输入税号"
            v-model="shopForm.nuonuoTaxNum"
          ></el-input>
          <el-button
            :disabled="!shopForm.nuonuoTaxNum"
            type="primary"
            size="small"
            @click="nuonuoCheck"
            >去认证</el-button
          > -->
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'nuonuoTaxNum');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'nuonuoTaxNum');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="nuonuoTaxNum"
              :on-exceed="limitTip"
              :limit="1"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(1, 'nuonuoTaxNum')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item class="submit-btn-container">
          <el-button type="primary" @click="submitForm('shopForm')">保存</el-button>
          <el-button @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      width="510px"
      :visible.sync="dialogMapVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <div slot="title" class="dialog-title">地图定位</div>
      <!-- <baidu-map
        v-if="dialogMapVisible"
        class="map"
        :center="center"
        :zoom="zoom"
        @ready="mapReadyHandler"
        @click="getPoint"
        :scroll-wheel-zoom="true"
      >
        <bm-control :offset="{ width: '10px', height: '10px' }">
          <el-input v-model="keyword" placeholder="请输入地名关键字"></el-input>
        </bm-control>
        <bm-local-search
          :keyword="keyword"
          :auto-viewport="true"
          :location="location"
          zoom="12.8"
          style="display: none"
        ></bm-local-search>
        <bm-marker :position="postionMap">
          <bm-info-window
            :show="show"
            @close="infoWindowClose"
            @open="infoWindowOpen"
            style="font-size: 14px"
          >
            <p>站点：{{ add.siteName }}</p>
            <p>站点地址：{{ add.site }}</p>
          </bm-info-window>
        </bm-marker>
      </baidu-map> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveStationAddress">保存</el-button>
      </div>
    </el-dialog>
    <!-- <baidu-map v-if="showMap" class="index-map"></baidu-map> -->
    <uploadImgComponent
      :isshow_uploadDialog="isshow_uploadDialog"
      @onClose="close_uploadDialog"
      @getChoose_ImgUrl="getChoose_ImgUrl"
      ref="childRef"
      :ImgLimits="ImgLimits"
      :uploadName="uploadName"
    ></uploadImgComponent>
  </div>
</template>

<script>
import { getShopCategorys, uploadImg, modifyShopInfo, getShopInfo } from "@/api/index.js";
import { mapState, mapActions } from "vuex";
import { gg2bd, bd2gg } from "@/utils/map.js";
import cityJson from "@/assets/js/citys.json";
import qrcode from "@xkeshi/vue-qrcode";
import html2canvas from "html2canvas";
import uploadImgComponent from "@/components/uploadImg";
let id = 0;
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      shopCategoryIdTagsOptions: [],
      dialogImageUrl: "",
      dialogVisible: false,
      shopForm: {
        shopLogo: "",
        edcShopQRcode: "",
        shopName: "",
        shopNotice: "",
        shopTel: "",
        businessHours: "",
        startTime: "",
        endTime: "",
        cityName: "",
        shopAddress: "",
        edcfuncTags: "",
        takeoutStatus: true,
        tangStatus: true,
        shopCategoryIdTags: [1, 1],
        needChoosePeopleNum: 1,
        payMethod: 1,
        isAutoClearTable: 1,
        isAutoOrderNumber: 1,
        mealMethod: 1,
        sendScope: "",
        sendType: 1,
        distributionPrice: "",
        minDistributionPrice: "",
        toSendPrice: "",
        shopFaceImage: "",
        shopImages: "",
        bannerImage: "",
        bannerImages: "",
        indexBackgroundImage: "",
        isVerified: 0,
        nuonuoTaxNum: "",
      },
      rules: {
        shopLogo: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        shopName: [
          {
            required: true,
            message: "请填写店铺名称",
            trigger: "blur",
          },
        ],
        shopNotice: [
          {
            required: true,
            message: "请填写店铺公告",
            trigger: "blur",
          },
        ],
        shopTel: [
          {
            required: true,
            message: "请填写联系电话",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "blur",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "blur",
          },
        ],
        cityName: [
          {
            required: true,
            message: "请选择门店所在地",
            trigger: "blur",
          },
        ],
        shopCategoryIdTags: [
          {
            required: true,
            message: "请选择店铺类型",
            trigger: "blur",
          },
        ],
        shopFaceImage: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        shopImages: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        // bannerImages: [
        //   {
        //     required: true,
        //     message: "请至少上传一张图片",
        //     trigger: "blur",
        //   },
        // ],
        // bannerImage: [
        //   {
        //     required: true,
        //     message: '请至少上传一张图片',
        //     trigger: 'blur'
        //   }
        // ],
        indexBackgroundImage: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
      },
      shopLogo: [],
      shopFaceImage: [],
      shopImages: [],
      bannerImage: [],
      indexBackgroundImage: [],
      bannerImages: [],
      nuonuoTaxNum: [],
      dialogMapVisible: false,
      mapCenter: "",
      center: { lng: 0, lat: 0 },
      zoom: 12.8,
      cityOptions: cityJson,
      keyword: "",
      location: "",
      show: false,
      postionMap: {
        //地图坐标
        lng: 120.211486,
        lat: 30.256576,
      },
      add: {
        siteName: "",
        site: "",
        jd: "",
        wd: "",
        desce: "",
        type: "",
        jgName: "",
        jgNum: "",
      },
      showMap: false,
      sendTypeList: [
        {
          name: "商家配送",
          value: 1,
        },
        {
          name: "达达配送",
          value: 2,
        },
        // {
        //   name: "蜂鸟配送",
        //   value: 3,
        // },
        {
          name: "闪送配送",
          value: 4,
        },
        {
          name: "美团配送",
          value: 5,
        },
        {
          name: "聚合配送",
          value: 6,
        },
      ],
      isshow_uploadDialog: false,
      uploadDisabled: false,
      ImgLimits: 1,
      uploadName: "",
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
      isOwn: (state) => state.isOwn,
    }),
  },
  components: {
    qrcode,
    uploadImgComponent,
  },
  mounted() {
    let url = window.location.href;
    if (this.isDsType && this.$route.path == "/setting") {
      this.$router.push({
        path: "/settingDsShop",
      });
    }
    this.getPageData();
  },
  methods: {
    getChoose_ImgUrl(val, name) {
      console.log(val, name, this.shopForm);
      if (val.length > 0) {
        this.isshow_uploadDialog = false;
        this.uploadDisabled = false;
        val.forEach((item) => {
          if (this[name].length >= this.ImgLimits) {
            return this.$notify.warning("所选图片已达限制");
          }
          if (name == "shopImages") {
            if (this.shopForm[name].length) {
              this.shopForm[name] += `,${item.image}`;
            } else {
              this.shopForm[name] = item.image;
            }
            this.shopImages.push({ name: "", url: item.image });
            return;
          }
          if (name == "bannerImages") {
            if (this.shopForm[name].length) {
              this.shopForm[name] += `,${item.image}`;
            } else {
              this.shopForm[name] = item.image;
            }
            this.bannerImages.push({ name: "", url: item.image });
            return;
          }
          this.shopForm[name] = item.image;
          switch (name) {
            case "shopLogo":
              this.shopLogo = [];
              this.shopLogo.push({ name: "", url: item.image });
              break;
            case "shopFaceImage":
              this.shopFaceImage = [];
              this.shopFaceImage.push({ name: "", url: item.image });
              break;
            case "bannerImage":
              this.bannerImage = [];
              this.bannerImage.push({ name: "", url: item.image });
              break;
            case "indexBackgroundImage":
              this.indexBackgroundImage = [];
              this.indexBackgroundImage.push({ name: "", url: item.image });
              break;
            case "bannerImages":
              this.bannerImages = [];
              this.bannerImages.push({ name: "", url: item.image });
              break;
            case "nuonuoTaxNum":
              this.nuonuoTaxNum = [];
              this.nuonuoTaxNum.push({ name: "", url: item.image });
              break;
            default:
              console.log("111");
          }
        });
      }
      this.$refs["shopForm"].validate();
    },
    ...mapActions(["updateShopInfo"]),
    getPageData() {
      this.getShopCategorys();
      this.showMap = true;
      setTimeout(() => {
        this.showMap = false;
        getShopInfo().then((shopInfo) => {
          this.updateShopInfo(shopInfo.data);
          let shopForm = JSON.parse(JSON.stringify(this.shop));
          let { lng, lat } = gg2bd(shopForm.longitude, shopForm.latitude);
          this.mapCenterInputText = `${shopForm.longitude},${shopForm.latitude}`;
          this.shopLogo = shopForm.shopLogo.length ? [{ url: shopForm.shopLogo }] : [];
          this.shopFaceImage = shopForm.shopFaceImage.length
            ? [{ url: shopForm.shopFaceImage }]
            : [];
          this.bannerImage = shopForm.bannerImage.length
            ? [{ url: shopForm.bannerImage }]
            : [];
          this.indexBackgroundImage = shopForm.indexBackgroundImage.length
            ? [{ url: shopForm.indexBackgroundImage }]
            : [];
          let shopImages = shopForm.shopImages.split(",");
          if (shopImages[0].length) {
            shopImages.forEach((val) => {
              this.shopImages.push({
                name: val,
                url: val,
              });
            });
          }
          let bannerImages = shopForm.bannerImages
            ? shopForm.bannerImages.split(",")
            : [];
          if (bannerImages[0] && bannerImages[0].length) {
            bannerImages.forEach((val) => {
              this.bannerImages.push({
                name: val,
                url: val,
              });
            });
          }
          let nuonuoTaxNum = shopForm.nuonuoTaxNum
            ? shopForm.nuonuoTaxNum.split(",")
            : [];
          if (nuonuoTaxNum[0] && nuonuoTaxNum[0].length) {
            nuonuoTaxNum.forEach((val) => {
              this.nuonuoTaxNum.push({
                name: val,
                url: val,
              });
            });
          }
          console.log(this.shopImages);
          shopForm.startTime = shopForm.businessHours.split("-")[0];
          shopForm.endTime = shopForm.businessHours.split("-")[1];
          shopForm.takeoutStatus = ~shopForm.edcfuncTags.indexOf("1") ? true : false;
          shopForm.tangStatus = ~shopForm.edcfuncTags.indexOf("2") ? true : false;
          let shopCategoryIdTags = shopForm.shopCategoryIdTags.split(",").map((val) => {
            return Number(val);
          });
          shopForm.shopCategoryIdTags = shopCategoryIdTags;
          this.shopForm = Object.assign(this.shopForm, shopForm);
          // let point = new BMap.Point(lng, lat);
          // let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
          // geocoder.getLocation(point, (rs) => {
          //   shopForm.cityName = [
          //     rs.addressComponents.province,
          //     rs.addressComponents.city,
          //     rs.addressComponents.district,
          //   ];
          //   console.log([
          //     rs.addressComponents.province,
          //     rs.addressComponents.city,
          //     rs.addressComponents.district,
          //   ]);
          //   this.mapCenter = shopForm.cityName.join("");
          // });
        });
      }, 500);
    },
    getShopCategorys() {
      getShopCategorys().then((res) => {
        if (res.code == 1) {
          let options = Array.from(res.data).map((item) => ({
            value: item.shopCategoryId,
            label: item.categoryName,
            children: [],
          }));
          options.forEach((val, index) => {
            getShopCategorys({
              shopCategoryId: val.value,
            }).then((res) => {
              if (res.code == 1) {
                let subOptions = Array.from(res.data).map((item) => ({
                  value: item.shopCategoryId,
                  label: item.categoryName,
                }));
                val.children = subOptions;
                this.shopCategoryIdTagsOptions = options;
              }
            });
          });
        }
      });
    },
    downQrcode() {
      let shareContent = document.getElementById("qrcode"); // 需要绘制的部分的 (原生）dom 对象 ，注意容器的宽度不要使用百分比，使用固定宽度，避免缩放问题
      let width = shareContent.offsetWidth; // 获取(原生）dom 宽度
      let height = shareContent.offsetHeight; // 获取(原生）dom 高
      let offsetTop = shareContent.offsetTop; //元素距离顶部的偏移量
      let canvas = document.createElement("canvas"); //创建canvas 对象
      let context = canvas.getContext("2d");
      let scaleBy = 4; //main.getPixelRatio(context);  //获取像素密度的方法 (也可以采用自定义缩放比例)
      canvas.width = 4 * width * scaleBy; //这里 由于绘制的dom 为固定宽度，居中，所以没有偏移
      canvas.height = 4 * (height + offsetTop) * scaleBy; // 注意高度问题，由于顶部有个距离所以要加上顶部的距离，解决图像高度偏移问题
      context.scale(scaleBy, scaleBy);
      html2canvas(document.getElementById("qrcode"), {
        useCORS: true,
        tainttest: true, //检测每张图片都已经加载完成
        scale: scaleBy, // 添加的scale 参数
        canvas: canvas, //自定义 canvas
        logging: false, //日志开关，发布的时候记得改成false
        width: width, //dom 原始宽度
        height: height, //dom 原始高度
      }).then((canvas) => {
        let dataURL = canvas.toDataURL("image/jpeg", 1.0);
        var a = document.createElement("a"); // 创建一个a节点插入的document
        var event = new MouseEvent("click"); // 模拟鼠标click点击事件
        a.download = "shop-qrcode.png"; // 设置a节点的download属性值
        a.href = dataURL; // 将图片的src赋值给a节点的href
        a.dispatchEvent(event);
      });
    },
    handleRemove(file, name) {
      console.log(file, name);
      if (name == "shopImages") {
        // 店铺实景
        let shopImages1 = this.shopForm.shopImages.split(",");
        let shopImages2 = this.shopForm.shopImages.split(",");
        shopImages1.splice(shopImages1.indexOf(file.url), 1);
        this.shopForm.shopImages = shopImages1.join(",");
        this.shopImages.splice(shopImages2.indexOf(file.url), 1);
      } else if (name == "bannerImages") {
        // 店铺实景
        let bannerImages1 = this.shopForm.bannerImages.split(",");
        let bannerImages2 = this.shopForm.bannerImages.split(",");
        bannerImages1.splice(bannerImages1.indexOf(file.url), 1);
        this.shopForm.bannerImages = bannerImages1.join(",");
        this.bannerImages.splice(bannerImages2.indexOf(file.url), 1);
      } else {
        this.shopForm[name] = "";
        this[name] = [];
      }
    },
    beforeRemove(file, fileList) {},
    limitTip(files, fileList) {
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item, name) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          if (name == "shopImages") {
            if (this.shopForm[name].length) {
              this.shopForm[name] += `,${res.data.url}`;
            } else {
              this.shopForm[name] = res.data.url;
            }
            return;
          }
          if (name == "bannerImages") {
            if (this.shopForm[name].length) {
              this.shopForm[name] += `,${res.data.url}`;
            } else {
              this.shopForm[name] = res.data.url;
            }
            return;
          }
          this.shopForm[name] = res.data.url;
        }
      });
    },
    submitForm(formName, cb) {
      console.log(this.shopForm, "shopForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let shopForm = JSON.parse(JSON.stringify(this.shopForm));
          shopForm.businessHours = `${shopForm.startTime}-${shopForm.endTime}`;
          shopForm.edcfuncTags = "";
          shopForm.edcfuncTags = shopForm.takeoutStatus ? "1" : "";
          shopForm.edcfuncTags +=
            shopForm.tangStatus && shopForm.takeoutStatus
              ? ",2"
              : shopForm.tangStatus
              ? "2"
              : "";
          shopForm.shopCategoryId = shopForm.shopCategoryIdTags[1] || "";
          shopForm.shopCategoryIdTags = shopForm.shopCategoryIdTags.join(",");
          shopForm.cityName = JSON.stringify(shopForm.cityName);
          shopForm.bannerImage = shopForm.bannerImage.length
            ? shopForm.bannerImage
            : "https://api.yichengshi.cn/images/edcmobile/default_banner.png";
          shopForm.bannerImages = shopForm.bannerImages.length
            ? shopForm.bannerImages
            : this.shop.edcShopType != 5
            ? "https://api.yichengshi.cn/images/edcmobile/default_banner.png"
            : "";

          shopForm.coodinateSystemType = 4;
          modifyShopInfo(shopForm).then((res) => {
            if (res.code == 1) {
              getShopInfo().then((shopInfo) => {
                this.updateShopInfo(shopInfo.data);
                if (cb) {
                  cb(shopInfo.data);
                  return;
                }
                this.$notify({
                  title: "提示",
                  message: "保存成功",
                  type: "success",
                  duration: 2000,
                });
                this.$router.push({
                  path: "/",
                });
              });
            } else {
              if (res.code == 11) {
                this.$notify({
                  title: "提示",
                  message: "如需在线支付，请申请网付认证",
                  type: "warning",
                  duration: 2000,
                });
                return;
              }
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "表单未完善，请检查店铺设置",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    resetForm() {
      (this.shopForm = {
        shopLogo: "",
        edcShopQRcode: "",
        shopName: "",
        shopNotice: "",
        shopTel: "",
        businessHours: "",
        startTime: "",
        endTime: "",
        cityName: "",
        shopAddress: "",
        edcfuncTags: "",
        takeoutStatus: true,
        tangStatus: true,
        shopCategoryIdTags: [1, 1],
        needChoosePeopleNum: 1,
        payMethod: 1,
        isAutoClearTable: 1,
        isAutoOrderNumber: 1,
        mealMethod: 1,
        sendScope: "",
        sendType: 1,
        distributionPrice: "",
        minDistributionPrice: "",
        toSendPrice: "",
        shopFaceImage: "",
        shopImages: "",
        bannerImage: "",
        bannerImages: "",
        nuonuoTaxNum: "",
        indexBackgroundImage: "",
        isVerified: this.shopForm.isVerified,
      }),
        (this.shopLogo = []);
      this.shopFaceImage = [];
      this.shopImages = [];
      this.bannerImage = [];
      this.bannerImages = [];
      this.nuonuoTaxNum = [];
      this.indexBackgroundImage = [];
      this.$refs.shopForm.resetFields();
    },
    mapReadyHandler({ BMap, map }) {
      this.center = this.mapCenter;
      console.log(this.mapCenter);
      this.zoom = 12.8;
    },
    getPoint(e) {
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.shopForm.cityName = [
          rs.addressComponents.province,
          rs.addressComponents.city,
          rs.addressComponents.district,
        ];
        this.add.site = rs.address;
        this.add.lng = rs.point.lng;
        this.add.lat = rs.point.lat;
        this.shopForm.shopAddress = rs.address;
        let { lng, lat } = bd2gg(rs.point.lng, rs.point.lat);
        this.shopForm.longitude = lng;
        this.shopForm.latitude = lat;
      });
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    cityNameCascaderHandler(value) {
      console.log(value);
      this.mapCenter = value.join("");
    },
    // showDialogMap() {
    //   if (!this.shopForm.cityName) {
    //     this.$notify({
    //       title: "警告",
    //       message: "请先选择城市",
    //       type: "warning",
    //       duration: 6000,
    //     });
    //     return;
    //   }
    //   this.dialogMapVisible = true;
    // },
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
    windowOpen(url) {
      location.href = url;
    },
    nuonuoCheck() {
      this.submitForm("shopForm", (data) => {
        this.windowOpen(data.nuonuoVerifyUrl);
      });
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
    },
    show_uploadDialog(val, name) {
      console.log(val, this[name].length);
      this.uploadDisabled = true;
      setTimeout(() => {
        this.uploadDisabled = false;
      }, 100);
      if (this[name].length >= val) {
        return this.$notify.warning("所选图片已达限制");
      }
      this.ImgLimits = val;
      this.uploadName = name;
      this.isshow_uploadDialog = true;
      this.$refs.childRef.rSelect = []; //  每次打开清除上一次的选择
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    padding: 12px 20px;
  }
  .tab-content {
    padding: 40px 48px;
  }
  .shopsetting-form {
    width: 100%;
    .qrcode-img {
      display: inline-block;
      position: relative;
      left: 0px;
      bottom: 0px;
      width: 300px;
      height: 450px;
      margin-right: 10px;
      .bg {
        width: 100%;
        height: 100%;
      }
      .logo {
        position: absolute;
        width: 30px;
        height: 30px;
        right: 136px;
        left: 140.5px;
        top: 243px;
        border-radius: 4px;
      }
      .name {
        position: absolute;
        display: block;
        width: 172px;
        color: #d07910;
        font-size: 10.8px;
        bottom: 64px;
        left: 72px;
        text-align: center;
      }
      .phone {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: 35px;
        left: 0;
        text-align: center;
        font-weight: bold;
      }
      .addresss {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: 17px;
        left: 0;
        text-align: center;
        transform: scale(0.6);
        white-space: nowrap;
        overflow: hidden;
      }
      .info {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: -1px;
        left: 0;
        text-align: center;
        transform: scale(0.6);
      }
      .scan-code-img {
        position: absolute;
        display: block;
        bottom: 147px;
        left: 111px;
      }
    }
    .el-form-item__content {
      .el-input,
      .el-textarea,
      .el-cascader {
        width: 380px;
      }
      .taxnum-input {
        width: 200px;
        margin-right: 10px;
      }
      .el-date-editor {
        width: 182px;
        margin-right: 14px;
      }
      .func-container {
        width: 144px;
        display: inline-block;
        height: 20px;
        line-height: 20px;
        margin-right: 20px;
      }
      .tips {
        font-size: 12px;
        line-height: 14px;
        color: #f56c6c;
        margin-left: 10px;
        & > i {
          margin-right: 6px;
        }
        .el-link {
          font-size: 14px;
          vertical-align: baseline;
          margin-left: 10px;
        }
      }
      .verified-status {
        margin-right: 18px;
      }
    }
    .submit-btn-container {
      margin: 40px 0 200px 0;
    }
    .inline-title {
      line-height: 40px;
      font-size: 14px;
      color: #333333;
      padding-left: 20px;
      background: #f8f8f8;
      margin: 45px 0 24px 0;
    }
    .el-radio {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
</style>
<style lang="less">
.banner-image {
  .el-upload-list--picture-card .el-upload-list__item {
    width: 443px;
    height: 148px;
  }
}
</style>
